export interface FormatLabelOptions {
  maxWordsPerLine?: number;
  maxCharsPerLine?: number;
  breakChar?: string; // '\n' o '<br/>'
}

export const splitLabel = (
  label: string,
  options: FormatLabelOptions = {}
): string => {
  const {
    maxWordsPerLine = 3,
    maxCharsPerLine,
    breakChar = '\n',
  } = options;

  if (!label) return label;

  if (maxCharsPerLine && label.length > maxCharsPerLine) {
    const words = label.split(' ');
    let lines: string[] = [];
    let currentLine = '';

    words.forEach((word) => {
      if ((currentLine + ' ' + word).trim().length > maxCharsPerLine) {
        lines.push(currentLine.trim());
        currentLine = word;
      } else {
        currentLine += ' ' + word;
      }
    });

    if (currentLine) lines.push(currentLine.trim());
    return lines.join(breakChar);
  }

  const words = label.split(' ');
  if (words.length > maxWordsPerLine) {
    const middle = Math.ceil(words.length / 2);
    return (
      words.slice(0, middle).join(' ') +
      breakChar +
      words.slice(middle).join(' ')
    );
  }

  return label;
};


export const formatLabelsObject = (
  labels: Record<string, string>,
  options?: FormatLabelOptions
): Record<string, string> => {
  if (!labels) return labels;

  return Object.fromEntries(
    Object.entries(labels).map(([key, value]) => [
      key,
      splitLabel(value, options),
    ])
  );
};